import Icon from './icon';
export default {
  Icon,
  title: 'Cuboid',
  hotkey: 'c'
};